import Vue from "vue";

export async function fetchComments({ commit }, payload) {
  commit("setLoading", true)

  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/posts/${payload.slug}/comments`,
      params: { page: payload.page }
    })

    if (payload.page > 1) {
      commit("setCommentsSeeMore", data.comments)
    } else {
      commit("setComments", data.comments)
    }
    
    commit("setTotalComments", data.total)
  } catch (e) {
  } finally {
    
  }
  
  commit("setLoading", false)
}

export async function createComment({ commit }, payload) {
  const { slug, content } = payload
  commit("setLoading", true)
  try {
    await Vue.axios({
      method: "POST",
      url: `/frontend/posts/${slug}/comments`,
      data: { comment: { content} }
    })
    commit("setLoading", false)
  } catch (e) {
    commit("setLoading", false)
  } finally {
    
  }
}

export async function deleteComment({ commit }, payload) {
  const { slug, commentId } = payload
  commit("setLoading", true)
  try {
    await Vue.axios({
      method: "DELETE",
      url: `/frontend/posts/${slug}/comments/${commentId}`,
    })
    commit("setLoading", false)
  } catch (e) {
    commit("setLoading", false)
  } finally {
    
  }
}